/* ============ Picklehead Rewards Ladder ============ */
(function () {
  var cfg = window.__ladderCfg;
  if (!cfg) return;

  var KEY = 'ph_ladder';
  var state;
  try { state = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { state = {}; }
  state.visit = !!state.visit; state.cart = !!state.cart; state.email = !!state.email; state.seen = !!state.seen;
  if (state.hidden) return; /* user chose "don't show again" */

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function tier() { return state.email ? 3 : state.cart ? 2 : state.visit ? 1 : 0; }
  function code() { var t = tier(); return t ? cfg.codes[t - 1] : null; }
  function pct()  { var t = tier(); return t ? cfg.pcts[t - 1] : '0%'; }

  var $ = function (s) { return document.querySelector(s); };
  var panel = $('#LadderPanel'), pill = $('#LadderPill');
  if (!panel || !pill) return;

  function toast(msg) {
    var t = $('#LadderToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t.__h);
    t.__h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function render() {
    $('#LadderPillPct').textContent = pct();
    $('#LadderCode').textContent = code() || '—';
    ['seg1', 'seg2', 'seg3'].forEach(function (id, i) {
      var done = [state.visit, state.cart, state.email][i];
      $('#Ladder' + id).classList.toggle('done', done);
      $('#LadderLab' + (i + 1)).classList.toggle('done', done);
    });
    $('#LadderRow2').classList.toggle('locked', !state.cart);
    $('#LadderRow2').classList.toggle('done', state.cart);
    $('#LadderRow3').classList.toggle('locked', !state.email);
    $('#LadderRow3').classList.toggle('done', state.email);
    var ef = $('#LadderEmailForm');
    if (ef) ef.style.display = state.email ? 'none' : 'flex';

    var head = $('#LadderHeadline'), sub = $('#LadderSub');
    if (state.email)      { head.textContent = cfg.tx.hEmail; sub.innerHTML = cfg.tx.sEmail; }
    else if (state.cart)  { head.textContent = cfg.tx.hCart;  sub.innerHTML = cfg.tx.sCart; }
    else                  { head.textContent = cfg.tx.hVisit; sub.innerHTML = cfg.tx.sVisit; }
  }

  function open()     { if (state.hidden) return; panel.classList.add('show'); pill.classList.remove('show'); }
  function minimize() { panel.classList.remove('show'); pill.classList.add('show'); }

  /* click outside closes */
  document.addEventListener('click', function (e) {
    if (!panel.classList.contains('show')) return;
    if (e.target.closest('#LadderPanel') || e.target.closest('#LadderPill')) return;
    minimize();
  });

  pill.addEventListener('click', open);
  var dismissBtn = $('#LadderDismiss');
  if (dismissBtn) dismissBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    state.hidden = true; save();
    panel.classList.remove('show'); pill.classList.remove('show');
  });
  var closeBtn = $('#LadderClose');
  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); minimize(); });

  /* step 2: any add-to-cart form submit */
  document.addEventListener('submit', function (e) {
    if (state.hidden) return; /* dismissed: no popups, no further accrual */
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (state.cart) return;
    state.cart = true; save(); render();
    setTimeout(function () { open(); toast(cfg.tx.toastCart); }, 600);
  }, true);

  /* step 3: email via Shopify customer form (flows to Klaviyo through Shopify sync) */
  var unlockBtn = $('#LadderEmailBtn');
  if (unlockBtn) unlockBtn.addEventListener('click', function () {
    var input = $('#LadderEmailInput');
    var v = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { toast(cfg.tx.toastBadEmail); input.focus(); return; }
    if (cfg.capture === 'klaviyo' && cfg.kKey && cfg.kList) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.kKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Rewards Ladder',
              profile: { data: { type: 'profile', attributes: { email: v } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.kList } } }
          }
        })
      }).catch(function () {});
    } else {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '\u2713');
      fd.append('contact[email]', v);
      fd.append('contact[tags]', 'newsletter,rewards-ladder');
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
    }
    state.email = true; state.cart = true; /* email completes the ladder — cart step auto-checks */
    save(); render();
    toast(cfg.tx.toastEmail);
  });

  /* copy code */
  var copyBtn = $('#LadderCopy');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var c = code(); if (!c) return;
    if (navigator.clipboard) navigator.clipboard.writeText(c);
    toast(cfg.tx.toastCopy + ' ' + c);
  });

  /* checkout auto-apply: route any checkout action through /discount/CODE */
  document.addEventListener('click', function (e) {
    if (state.hidden && !state.cart && !state.email) return; /* dismissed at visit-only: no auto-apply */
    var c = code(); if (!c) return;
    var el = e.target.closest('a[href="/checkout"], a.checkout, button[name="checkout"]');
    if (!el) return;
    e.preventDefault();
    window.location.href = '/discount/' + encodeURIComponent(c) + '?redirect=%2Fcheckout';
  }, true);

  /* entrance */
  render();
  if (window.Shopify && window.Shopify.designMode) {
    /* theme editor: show immediately so it can be styled */
    state.visit = true; open();
  } else if (!state.seen) {
    setTimeout(function () {
      state.visit = true; state.seen = true; save(); render(); open();
    }, cfg.delay * 1000);
  } else {
    pill.classList.add('show');
  }
})();
